










































// import Vue from 'vue'
import { createComponent, ref, reactive, watch, computed } from '@vue/composition-api'
import { eventType, eventTypePage } from '@/assets/event'
import { currentPage } from '@/assets/page'
import { currentNode } from '@/assets/node'
import { findTreePath, getParentRef, deepClone } from '@/assets/util'
// import VueMonaco from '@/components/vue-monaco/index.vue'
import { MessageBox, Message } from 'element-ui'
// import Modal from '@/components/v2/modal.vue'
import { setCodeState } from '@/assets/code-edit'

export default createComponent({
  props: {
    schema: Object,
    schemaData: Object,
    from: {
      type: String,
      default: 'node'
    }
  },
  components: {
    // Modal
  },
  setup (props, ctx) {
    type FormEvent = {
      eventType: string
      targetNodeIdPath?: string[]
      fxCode: string
      desc: string
      [k: string]: any
    }
    const eventList = ref<FormEvent[]>([])
    const editItemIndex = ref(-1)
    const defaultForm: FormEvent = {
      eventType: '',
      targetNodeIdPath: [],
      fxCode: '',
      desc: ''
    }
    const isFromPage = computed(() => props.from === 'page')
    const form = reactive<FormEvent>(deepClone(defaultForm))
    const eventTypeOptions = computed(() => isFromPage.value ? eventTypePage : eventType)
    const showAddForm = ref(false)
    let itemTitle: string
    let itemId: string

    watch(() => [currentNode.value, currentPage.value], () => {
      showAddForm.value = false
    })

    watch(() => props.schemaData, val => {
      if (val) {
        itemTitle = val.title
        itemId = val.id
        const { pref, field } = getParentRef(props.schema!.field, val)
        eventList.value = deepClone(pref[field]).filter(Boolean)
      }
    }, { deep: true })

    const handleConfirm = () => {
      if (!form.eventType) {
        return Message.error('请选择事件类型')
      }
      if (editItemIndex.value > -1) {
        eventList.value[editItemIndex.value] = deepClone(form)
      } else {
        eventList.value.push(deepClone(form))
      }
      ctx.emit('change', eventList.value)
      // 重置表单
      resetForm(defaultForm)
      showAddForm.value = false
    }
    const resetForm = (obj: FormEvent) => {
      Object.keys(obj).forEach(k => {
        form[k] = obj[k]
      })
    }
    const handleCancel = () => {
      resetForm(defaultForm)
      showAddForm.value = false
    }
    const handleEditCode = () => {
      // console.log({ isNew: true, itemId, eventIndex: editItemIndex.value, setInSchema: true })
      setCodeState(`${itemTitle} ${form.eventType}`, form.fxCode, (val: string) => {
        form.fxCode = val
        if (form.eventType) {
          handleConfirm()
        }
      }, undefined, { isNew: true, itemId, eventIndex: editItemIndex.value, setInSchema: true })
    }
    return {
      // showModal,
      // canMount,
      form,
      eventList,
      eventTypeOptions,
      // isFromPage,
      showAddForm,
      editItemIndex,
      handleConfirm,
      handleCancel,
      handleEditCode,
      handleAdd () {
        editItemIndex.value = -1
        showAddForm.value = true
      },
      handleEdit (item: FormEvent, i: number) {
        // showModal.value = true
        resetForm(item)
        editItemIndex.value = i
        showAddForm.value = true
        handleEditCode()
      },
      handleDel (i: number) {
        MessageBox.confirm('确定要删除吗？').then(() => {
          showAddForm.value = false
          eventList.value.splice(i, 1)
          ctx.emit('change', eventList.value)
        })
      }
    }
  }
})
